import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ItemObject } from 'src/app/models/orders/item/item-object.model';
import { OrderSummary } from 'src/app/services/api/orders/orders.service';

@Component({
  selector: 'app-order-tabs',
  templateUrl: './order-tabs.component.html',
  styleUrls: ['./order-tabs.component.css']
})
export class OrderTabsComponent implements OnInit {

  @Input() summary: OrderSummary;
  @Input() params: any;
  @Input() isps: any[];

  @Output() cancelOrderEvent = new EventEmitter();
  @Output() decompositeOrderEvent = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  cancelOrder() {
    this.cancelOrderEvent.emit();
  }

  decompositeOrder() {
    this.decompositeOrderEvent.emit();
  }

}